var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1973_19959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.8984H11.0508V13.6719H12.8281C15.1113 13.6719 16.4238 12.3115 16.4238 10.3359C16.4238 8.3877 15.1318 7 12.8828 7H9V16.8984ZM11.0508 12.0176V8.68164H12.5C13.7168 8.68848 14.3115 9.35156 14.3047 10.3359C14.3115 11.334 13.7168 12.0176 12.5 12.0176H11.0508Z",
    fill: "#CCCFD1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 18.0137L4.28418 18.2979L8 14.582V17.4105L5.69839 19.7121L5.98632 20H18.0137L20 18.0137V5.98632L18.0137 4H6.06098L4 6.00307V18.0137ZM11.0508 14.3597L9 16.4105V13.582L11.0508 11.5312V12.0176H12.5C13.0846 12.0176 13.5257 11.8598 13.8254 11.5851L11.7386 13.6719H11.0508V14.3597ZM17.0182 8.39229L19.7072 5.70328L18.293 4.28906L15.7413 6.84075C15.902 6.95624 16.0537 7.08344 16.1957 7.22223C16.5452 7.56381 16.8188 7.95908 17.0182 8.39229ZM15.0214 7.56064C15.6134 7.93888 16.0293 8.49108 16.2473 9.16316L13.9089 11.5015C14.1767 11.2093 14.3079 10.8077 14.3047 10.3359C14.3089 9.72778 14.0835 9.24225 13.6237 8.95835L15.0214 7.56064ZM2 5.15789L5.2492 2H18.8421L22 5.15789V18.8421L18.8421 22H5.15789L2 18.8421V5.15789Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1973_19959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParking);
export default __webpack_public_path__ + "static/media/icon-parking.f0ffba454669cb4ce2773674c5ff8c99.svg";
export { ForwardRef as ReactComponent };